module.exports = __webpack_public_path__ + "static/media/symbols.40951c85.svg";